import styled from 'styled-components';

export const ThumbnailInner = styled.div`
  padding-top: 28.125%;
`;
